import { getUserId, getMerchantId } from './user.service';
import { request } from './request';

export async function getBCAMerchantAccountBalance(
  abortController = null,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const merchantId = getMerchantId();
  const accountType = 'VODTRA';
  const res = await request(
    `merchant-accounts?userReference=${userId}&accountType=${accountType}&merchantID=${merchantId}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    showToastOnError,
    suppressTealiumEvent,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res.status === 200) {
    return res.result;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse(
      'error response from the merchant-accounts GET endpoint',
      true,
      suppressTealiumEvent,
      res,
    );
  }
}
